<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">设备信息</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="Name">
            <el-input v-model="Name" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="IP地址" prop="IP">
            <el-input v-model="IP" placeholder="请输入IP地址"></el-input>
          </el-form-item>

          <el-form-item label="是否在线">
            <el-select v-model="IsOnline" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in EqStatusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select v-model="EquType" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in EquTypeArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.ItemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              v-loading="searching"
              element-loading-text="加载中..."
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Name"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="IP" label="IP地址">
              </el-table-column>
              <el-table-column prop="Port" label="端口号">
              </el-table-column>
               <el-table-column prop="EquType" label="设备类型" :formatter="EquTypeToNameConverter">
              </el-table-column>
              <el-table-column prop="EquLogonName" label="用户名">
              </el-table-column>
              <el-table-column prop="Status" label="是否在线">
                <template slot-scope="scope">
                  <span v-if="scope.row.Status == false" style="color: red"
                    >离线</span
                  >
                  <span v-if="scope.row.Status == true" style="color: green"
                    >在线</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "EquipmentView",
  controller: "UI",
  action: "EquipmentView",
  data() {
    return {
      searching: false, // 搜索中...
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      EquipmentType: "", //设备类型
      Name: "", //设备名称
      IP: "", //IP地址
      EqStatusArr: [
        { value: 0, label: "离线" },
        { value: 1, label: "在线" },
      ],
      IsOnline: "", //在线是否
      EquTypeArr: [],
    };
  },
  created: function () {
    this.getEquType();
  },
  mounted: function () {
    this.search();
    this.logInfo.ActionName = "设备信息查看";
    this.logInfo.LogMessage = "设备信息查看";
    this.logInfo.ModuleName = "设备资源监控";
    this.logInfo.PageName = "设备信息列表页";
    this.addOperationLog();
  },
  methods: {
    getEquType() {
      this.config
        .getUValue("EquMonitorSubSystem:EquType", "")
        .then((d) => {
          this.EquTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    search() {
      this.searching = true;
      let searchInfo = {
        Name: this.Name, //设备名称
        IP: this.IP, //设备名称
        Status: this.IsOnline, //在线是否
        EquType: this.EquType,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .FindEquipmentByPaging(searchInfo)
        .then((r) => {
          //console.log("1");
          this.searching = false;
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    clearsearch() {
      this.Name = "";
      this.IsOnline = "";
      this.IP = "";
      this.EquType = "";
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/equMonitor/UI/EquipmentInfo",
        query: {
          InfoId: row.ID,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      console.log(index);
      console.log(row);
      this.$router.push({
        path: "/plugin/equMonitor/UI/EquipmentInfo",
        // name: 'mallList',
        query: {
          InfoId: row.ID,
          type: "query",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/equMonitor/UI/EquipmentInfo",
        query: {
          type: "add",
        },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DeleteEquipment(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.logInfo.ActionName = "设备信息删除";
              this.logInfo.LogMessage = r
                ? "设备信息删除成功"
                : "设备信息删除失败";
              this.logInfo.ModuleName = "设备资源监控";
              this.logInfo.PageName = "设备信息列表页";
              this.addOperationLog();
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    EquTypeToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const Description = this.EquTypeArr.map((item) => {
        if (item.ItemValue == data) return item.Description;
      }).join("");
      if (Description == null || Description == "") {
        return data;
      }
      return Description;
    },
  },
};
</script>
